import axiosInstance from "./axiosInstance";
import { KycProfile } from "../../types/dashboard";

const API_BASE_URL = process.env.REACT_APP_CHECKIN_API_URL ?? "https://dev-api.checkin.degencoinflip.com/v1"; // Replace with your actual API base URL

interface ApiResponse {
  payload: KycProfile;
}

/**
 * Fetches the dashboard data.
 *
 * @returns The user's KYC profile data.
 */
export const getDashboardData = async (): Promise<KycProfile> => {
  console.log("Fetching dashboard data...");
  const response = await axiosInstance.get<ApiResponse>(
    `${API_BASE_URL}/kyc-profile`
  );
  return response.data.payload;
};

/**
 * Fetches the dashboard data.
 *
 * @returns The user's KYC profile data.
 */
export const initGetKycProfile = async (): Promise<KycProfile> => {
  console.log("posting kyc profile...");
  const response = await axiosInstance.post<ApiResponse>(
    `${API_BASE_URL}/kyc-profile`
  );
  return response.data.payload;
};
